<template>
	<div id="hrms75e-detail-tab1" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab1">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRMS75EC7']['10'] }}
      </h3>
    </div>
    <div id="tab1" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
        <div class="detail detail-responsive panel-detail-filter">
        		 <hrms-table
        		 						 :columns="detailTab1Columns"
                         :data="detail.table"
                         :searchDisp="false"
                         :selectRowBool="false"
                         :selectBtnDisp="true"
                         :selectEvent="selectEvent"
                         :confirmSelectBtnDisp="false"
                         ref="Tab1" />

        </div>
      </div>
      <div class="modal-footer" >
        <button type="button" class="btn bg-color-skin pull-left" data-dismiss="modal" @click="triggerTab1()"><i class="fa fa-check-circle"></i>{{ labelsButton['approve'] }}</button>
        </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'hrms75e-detail-tab1',
  data () {
    return {
      selectedRow: []
    }
  },
  props: [
    'labels',
    'labelsButton',
    'nowLang',
    'detail',
    'detailTab1Columns',
    'setAddCodcours'
  ],
  methods: {
    triggerTab1 () {
      this.$refs.Tab1.$emit('$selectEventBuiltIn')
    },
    selectEvent (checkedDataRows) {
      this.setAddCodcours(checkedDataRows)
    }
  }
}
</script>



// WEBPACK FOOTER //
// detailTab1.vue?7d6d03a2